import React, { useEffect } from "react";
import Layout from "./Layout";
import Landingpage from "../components/Landingpage";

const Homepages = () => {
  return (
    <Layout>
      <Landingpage />
    </Layout>
  );
};

export default Homepages;
